/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Layout_Header_Light_ModeInputs */



/**
* | output |
* | --- |
* | "Light mode" |
*
* @param {Layout_Header_Light_ModeInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const layout_header_light_mode = /** @type {((inputs?: Layout_Header_Light_ModeInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Layout_Header_Light_ModeInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Heller Modus")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Mode clair")
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ ("浅色模式")
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ ("淺色模式")
	if (locale === "ko") return /** @type {LocalizedString} */ ("라이트 모드")
	return /** @type {LocalizedString} */ ("Light mode")
});